import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  useLocation,
} from "react-router-dom";
import { Routes } from "./Routes";
import { ProtectedRoute } from "./ProtectedRoute";
import { AccountRouter } from "./account";
import { AdminRouter } from "./admin";
import { EventRouter } from "./events";
import { GameRouter, GuestGameRouter } from "./games";
import { WallRouter } from "./games/Wall";
import { HostRouter } from "./host";
import { MessageRouter } from "./messages";
import { PlaceRouter } from "./places";
import { PostRouter } from "./user";
import { useStateValue } from "providers";
import { BetaSignup, ChangePassword, Home, HolidaysList, HostBetaSignup, Login, Logout, PageLayout, Reset, Signup } from "containers";

const PrivateRoute = () => {
  const [{ session }, dispatch] = useStateValue();
  const location = useLocation();

  return session.user ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace={true} />
  );
};

const HomeRouter = () => {
  const [{ session }, dispatch] = useStateValue();

  switch (session?.user?.roles?.[0]?.slug) {
    case "admin":
      return <AdminRouter />;
    case "host:owner":
    case "host:manager":
      return <HostRouter />;
    case "user":
      return <Home />;
    default:
      return <Home />;
  }
};

export const Router = () => {
  const [{ session }, dispatch] = useStateValue();

  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Routes>
        <Route
          path="/change_password/:reset_token"
          element={<ChangePassword />}
        />
        <Route path="/guest/*" element={<GuestGameRouter />} />
        <Route path="games/wall/*" element={<PageLayout />}>
          <Route path="*" element={<WallRouter />} />
        </Route>
        <Route path="/holidays" element={<HolidaysList />} />
        <Route path="/beta" element={<BetaSignup />} />
        <Route path="/beta/host" element={<HostBetaSignup />} />
        <Route path="/signup" element={<Signup />} />
        <Route exact path="/logout" element={<Logout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/password_reset" element={<Reset />} />
        <Route path="/" element={<HomeRouter />} />
        <Route path="/*" element={<PrivateRoute />}>
          <Route path="account/*" element={<AccountRouter />} />
          <Route path="admin/*" element={<AdminRouter />} />
          <Route
            element={
              <ProtectedRoute roles={["admin", "host:owner", "host:manager"]} />
            }
          >
            <Route path="host/*" element={<HostRouter />} />
          </Route>
          <Route path="events/*" element={<EventRouter />} />
          <Route path="games/*" element={<GameRouter />} />
          <Route path="messages/*" element={<MessageRouter />} />
          <Route path="places/*" element={<PlaceRouter />} />
          <Route path="post/*" element={<PostRouter />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
